var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',{staticClass:"dashboard-main"},[_c('img',{staticClass:"c-avatar-img",attrs:{"src":"img/luthrahorse.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }